import { CanActivateFn } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';

export const authGuard = createAuthGuard<CanActivateFn>(async (_route, _state, { authenticated, keycloak }) => {
  if (!authenticated) {
    await keycloak.login({ redirectUri: window.location.href });
    return false;
  }
  return true;
});
